module.exports = __webpack_public_path__ + "static/media/autokar3 (4).670d27c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar3 (4).jpg
// module id = 861
// module chunks = 0